/**
 * Divi Pro Gallery
 * Version: 1.0.0
 * Author: Fahim Reza
 * Author URI: https://wppaw.com
 * Plugin URI: https://divielite.com/pro-gallery/
 *
 * Help: https://github.com/sid04naik/jquery.plugin-boilerplate
 */

(function ($, window, document, undefined) {
    'use strict';

    let plugin;
    const PLUGIN_NAME = 'divi_pro_gallery';

    class Plugin {
        constructor(element) {
            this._element = element;
            this.$_element = $(this._element);
            this.$_config = this.$_element.find('.divi-pro-gallery').data('config');
            this.$_items = this.$_element.find('.dpg-items');
            this.$_item = this.$_items.find('.dpg-item');
            this._pluginName = PLUGIN_NAME;
            this._defaults = $.fn[PLUGIN_NAME].defaults;
            this._settings = $.extend({}, this._defaults, this.$_config);
            this._filterValue = '*';
            this._init();
        }
    }

    $.extend(Plugin.prototype, {
        _init: function () {
            let plugin = this;
            if ('grid' === plugin._settings.type) {
                plugin._grid();
            } else if ('masonry' === plugin._settings.type) {
                plugin._masonry();
            } else if ('highlight' === plugin._settings.type) {
                plugin._highlight();
            } else if ('slider' === plugin._settings.type) {
                plugin._slider();
            } else {
                this._grid();
            }

            if (plugin._settings.hasFilters) {
                plugin._filters();
            }

            if (plugin._settings.lightbox) {
                plugin._lightbox();
            }
        },

        _filters: function () {
            let plugin = this;

            this.$_element.on('click', '.dpg-filters a', function (e) {
                e.preventDefault();

                if ($(this).parent().hasClass('current')) {
                    return;
                }

                plugin._filterValue = $(this).attr('data-filter');
                plugin.$_element.find('.dpg-filters .current').removeClass('current');
                plugin.$_element
                    .find(".dpg-filters a[data-filter='" + plugin._filterValue + "']")
                    .parent()
                    .addClass('current');

                plugin._reset();

                plugin.$_items.isotope({filter: plugin._filterValue}).isotope('layout');

                if ('grid' === plugin._settings.type) {
                    plugin.$_item.each(function (i, item) {
                        plugin._loadImage(i);
                    });
                }
            });
        },

        _lightbox: function () {
            let plugin = this;
            let lightbox_actions = [];
            let actions = plugin._settings.lightboxOpts;

            if (actions.length > 0) {
                lightbox_actions = actions;
            }

            plugin.$_items.find('[data-fancybox="dpg-gallery"]').fancybox({
                buttons: lightbox_actions,
                animationEffect: 'fade',
            });
        },

        _grid: function () {
            let plugin = this;
            let data = {
                top: 0,
                left: 0,
                position: 0,
                height: this.$_item.height(),
                width: this.$_item.width(),
            };

            plugin.$_item.each(function (i, item) {
                $(item).data('size', data);

                $(item).css({
                    height: data.width,
                });

                $(item).find('.dpg-square').css({
                    height: data.width,
                });

                plugin._loadImage(i);
            });

            plugin.$_items.isotope({
                resizesContainer: false,
                itemSelector: '.dpg-item',
                layoutMode: 'packery',
                packery: {
                    gutter: parseInt(plugin._settings.gutter),
                },
            });
        },

        _masonry: function () {
            let plugin = this;
            let data = {
                top: 0,
                left: 0,
                width: this.$_item.width(),
                height: this.$_item.height(),
                position: 0,
            };

            this.$_item.each(function (i, item) {
                $(item).data('size', data);

                $(item).find('.pic').css({
                    width: data.width,
                });

                plugin._loadImage(i);
            });

            this.$_items.isotope({
                itemSelector: '.dpg-item',
                layoutMode: 'packery',
                packery: {
                    gutter: parseInt(plugin._settings.gutter),
                },
            });
        },

        _highlight: function () {
            let plugin = this,
                size,
                containerWidth = this.$_element.find('.dpg-items').width(),
                columns = this._settings.columns,
                viewport = document.documentElement.clientWidth;

            if (viewport < 767) {
                columns = this._settings.columnsPhone;
            } else if (viewport < 980) {
                columns = this._settings.columnsTablet;
            } else {
                columns = this._settings.columns;
            }

            if (this._settings.gutter > 0) {
                size = (containerWidth - this._settings.gutter * (columns - 1)) / columns;
            } else {
                size = Math.floor((containerWidth / columns) * 1000) / 1000;
            }

            this.$_item.each(function (i, item) {
                let data = {};

                data.width = size;
                data.height = size;

                $(item).data('size', data).data('position');
                $(item).not('.dpg-item-highlight').css($(item).data('size'));

                $(item)
                    .not('.dpg-item-highlight')
                    .find('.pic')
                    .css({
                        width: $(item).data('size').width,
                        height: $(item).data('size').height,
                    });

                let h_height = $(item).data('size').height * 2 + plugin._settings.gutter;
                let h_width = $(item).data('size').width * 2 + plugin._settings.gutter;

                $('.dpg-item-highlight').css({
                    height: h_height,
                    width: h_width,
                });

                $('.dpg-item-highlight').find('.pic').css({
                    height: h_height,
                    width: h_width,
                });

                plugin._loadImage(i);
            });

            this.$_items.isotope({
                itemSelector: '.dpg-item',
                layoutMode: 'packery',
                packery: {
                    gutter: parseInt(plugin._settings.gutter),
                },
            });
        },

        _slider: function () {
            let plugin = this;
            let sliderOpts = plugin._settings.slider;
            this.slider = new Splide('.splide', {
                type: sliderOpts.slider_type,
                arrows: sliderOpts.slider_arrows,
                height: sliderOpts.slider_height,
                speed: parseInt(sliderOpts.slider_speed),
                gap: parseInt(plugin._settings.gutter),
                pagination: false,
                perPage: parseInt(plugin._settings.columns),
                breakpoints: {
                    767: {
                        perPage: parseInt(plugin._settings.columnsPhone),
                    },
                    980: {
                        perPage: parseInt(plugin._settings.columnsTablet),
                    },
                },
            });

            this.slider.mount();
        },

        _reset: function () {
            let plugin = this;

            if ('grid' === plugin._settings.type) {
                this._grid();
            } else if ('masonry' === plugin._settings.type) {
                this._masonry();
            } else if ('highlight' === plugin._settings.type) {
                this._highlight();
            } else if ('slider' === plugin._settings.type) {
                this._slider();
            } else {
                this._grid();
            }
        },

        _loadImage: function (index) {
            let source = this.$_item.eq(index).find('.pic'),
                size = {};
            let img = new Image();

            img.onload = function () {
                size = {width: this.width, height: this.height};
                source.data('size', size);
            };

            if ('undefined' !== source.attr('src')) {
                img.src = source.attr('src');
            } else {
                img.src = source.data('src');
            }
        },
    });

    $.fn[PLUGIN_NAME] = function (options) {
        this.each(function () {
            if (!$.data(this, 'plugin_' + PLUGIN_NAME)) {
                $.data(this, 'plugin_' + PLUGIN_NAME, new Plugin(this, options));
            }
        });
        return this;
    };

    $.fn[PLUGIN_NAME].defaults = {};
})(jQuery, window, document);

jQuery(document).ready(function () {
    let dpgWrap = jQuery('.divi_pro_gallery');
    jQuery.each(dpgWrap, function () {
        jQuery(this).divi_pro_gallery();
    });
});
